import { render, staticRenderFns } from "./postYoutube.vue?vue&type=template&id=78fd2ee4&"
import script from "./postYoutube.vue?vue&type=script&lang=js&"
export * from "./postYoutube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports